@if (loading) {
  <img id="vf-loader" class="d-block mx-auto mt-5" src="/assets/images/spinner_logo.svg" alt="spinner" />
}

@if (showPagination) {
  <app-pagination
    [class.invisible]="(tableRows?.length ?? 0) <= pageSize || loading"
    [pageNumber]="pageNumber"
    [disabled]="disabled"
    [isDynamic]="dynamicPagination"
    [exactRows]="exactRows"
    [pageSize]="pageSize"
    (pageChanged)="handlePageChanged($event)"
    [tableRows]="tableRows"
    [totalRowsPayload]="totalRowsPayload"
  ></app-pagination>
}
